.cost-review-summary {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-size: 13px;
  background-color: var(--success--background-color--2);
  padding: var(--space-8);
  gap: var(--space-8);
}

.ship-date {
  display: flex;
  align-items: center;
  font-weight: var(--font-weight-bold);
}

.ship-date-input {
  width: 160px;
  line-height: 0;
  margin-top: 5px;
  margin-left: 5px;
}

.cost-summary-section {
  display: flex;
  flex-direction: column;
  gap: var(--space-8);
}

.line-item {
  display: flex;
  justify-content: space-between;
}

.line-item-with-icon {
  display: flex;
  gap: 5px;
  align-items: top;
}

.info-icon {
  height: 13px;
  width: 13px;
  color: var(--grey-600);
}

.total {
  font-weight: var(--font-weight-bold);
  padding-top: var(--space-8);
  border-top: 1px solid var(--default--border-color--1);
}

.hide-ship-date {
  display: none;
}

.tooltip-icon {
  width: var(--space-16);
  color: var(--default--icon-button--fill-color--1);
  cursor: pointer;
}

.tooltip-wrapper {
  margin-right: var(--space-8);
  position: relative;
  top: 2px;
}
